import { Box, Tooltip } from "@mui/material";

const DisabledButtonWithTip = ({ ...props }) => {
  const tip = props?.tip;
  const label = props?.label || "Disabled";
  const width = props?.width || "120px";

  return (
    <Tooltip
      title={tip || ""}
      placement="left"
      disableFocusListener
      disableTouchListener
    >
      <Box
        sx={{
          ...props?.sx,
          float: "right",
          ml: 2,
          width: width,
          backgroundColor: "#0000001f",
          color: "#00000042",
          borderRadius: "10px",
          textAlign: "center",
          padding: "8px 10px",
          cursor: "not-allowed",
          fontSize: "0.875rem",
          fontWeight: "bold",
          textTransform: "uppercase",
          fontFamily: "Gotham Rounded",
        }}
      >
        {label}
      </Box>
    </Tooltip>
  );
};

export default DisabledButtonWithTip;
